import React from "react";
import styles from "./homepagebestsellproduct.module.css";
import ProductCard from "../ProductCard";
import { useTranslation } from "react-i18next";
const BestSellingProduct = ({ best_selling_products }) => {
  const { t } = useTranslation();
  // Ensure we only take the top 10 products
  const topProducts = best_selling_products.slice(0, 12);

  return (
    <div className="container-fluid mt-3vw">
      <h2 className={styles.mt}>{t("top_product_in_week")}</h2>
      <div className="row">
        {topProducts.map((product, idx) => (
          <div className="col-md-3" key={idx}>
            <ProductCard
              productId={product.productId}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BestSellingProduct;
